import { getImageFromPage } from '~core';
import slugify from 'slugify';
import { jsPDF } from 'jspdf';
import { addWatermark } from '~src/utils';

/**
 * Nome file usato da tutte le griglie provino.
 */
const getGridFileName = (metadata) =>
  slugify(
    `Provino-${metadata.projectTypeName}${
      metadata.templatesCategoryName ? `-${metadata.templatesCategoryName}` : ''
    }${metadata.servizioName ? `-${metadata.servizioName}` : ''}${
      metadata.formatName ? `-${metadata.formatName}` : ''
    }.pdf`
  );

/**
 * Immagine della pagina pronta per il PDF, con watermark per le istanze demo.
 */
const getGridImage = async (page, user) => {
  const image = await getImageFromPage(page);

  if (user.org_pointer.tipo_istanza === 'demo') {
    return addWatermark(image);
  }

  return image;
};

/**
 * Genera una griglia provino a maglia fissa: margine superiore e sinistro,
 * spaziatura costante tra colonne e righe, contando quanti elementi entrano
 * nel foglio.
 *
 * Usata dai layout che replicano le misure richieste da una specifica
 * macchina: taglierine (es. taglierina-memento-santini) e stampanti (es.
 * ricordino-152x102-cp5000, con margini ricavati dal formato del ricordino).
 *
 * @param {object} staticGridParameters
 * @param {object} staticGridParameters.pdf - margini in mm (topMargin, leftMargin)
 * @param {object} staticGridParameters.rowInfo - elementi per riga (maxItemsToFit) e spaziatura orizzontale in mm (padding, 0 = elementi incollati)
 * @param {object} staticGridParameters.columnInfo - elementi per colonna (maxItemsToFit) e spaziatura verticale in mm (padding, 0 = elementi incollati)
 */
export const generateGridWithFixedMargins = async ({
  staticGridParameters,
  gridParameters,
  selectedPagesByUser,
  metadata,
  user,
}) => {
  const pdfGrid = new jsPDF(gridParameters.pdf.orientation, 'mm', [
    gridParameters.pdf.width,
    gridParameters.pdf.height,
  ]);

  let pageNumber = 0;

  for (let page of selectedPagesByUser) {
    pageNumber++;
    if (pageNumber > 1) {
      pdfGrid.addPage();
    }

    const image = await getGridImage(page, user);

    let top = staticGridParameters.pdf.topMargin;

    for (let j = 0; j < staticGridParameters.columnInfo.maxItemsToFit; j++) {
      let left = staticGridParameters.pdf.leftMargin;

      for (let i = 0; i < staticGridParameters.rowInfo.maxItemsToFit; i++) {
        pdfGrid.addImage(
          image,
          'JPEG',
          left,
          top,
          gridParameters.format.width,
          gridParameters.format.height
        );
        left +=
          gridParameters.format.width + staticGridParameters.rowInfo.padding;
      }

      top +=
        gridParameters.format.height + staticGridParameters.columnInfo.padding;
    }
  }

  return { pdfGrid, fileName: getGridFileName(metadata) };
};

export default generateGridWithFixedMargins;
